import api from "./api";

const authService = {
  login: ({ email, password }) => {
    console.log("🔐 AUTH LOGIN CALLED", { email });
    return api.post("/auth/login", { email, password });
  },

  googleLogin: ({ token }) => {
    console.log("🔐 GOOGLE LOGIN CALLED", token);
    return api.post(
      "/auth/google-login",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  register: (data) => {
    console.log("📝 AUTH REGISTER", data);
    return api.post("/auth/register", data);
  },

  googleSignup: ({ token }) => {
    console.log("📝 GOOGLE AUTH SIGNUP", token);
    return api.post(
      "/auth//google-signup",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },

  registerVendor: (data) => {
    console.log("🏭 VENDOR REGISTER", data);
    return api.post("/vendors/register", data);
  },

  getMe: () => {
    console.log("👤 AUTH GET ME CALLED");
    return api.get("/auth/me");
  },
};

export default authService;
